import { NavLink, useLocation } from 'react-router-dom';

// @ts-expect-error: untyped prop
export const LinkWithQuery = ({ children, to, ...props }) => {
    const { search } = useLocation();

    return (
        <NavLink to={to + search} {...props}>
            {children}
        </NavLink>
    );
};
